export const commonInputProps = {
  required: {
    type: Boolean,
    default: false
  },
  id: {
    type: String,
    default: '',
    required: true
  },
  inputProps: {
    type: Object,
    default: () => {}
  },
  label: {
    type: String,
    default: ''
  },
  labelElProps: {
    type: Object,
    default: () => {}
  },
  value: {
    type: [String, Number, Date],
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  },
  placeholder: {
    type: String,
    default: ''
  },
  readonly: {
    type: Boolean,
    default: false
  },
  inline: {
    type: Boolean,
    default: false
  },
  autoFocus: {
    type: Boolean,
    default: false
  },
  divElProps: {
    type: Object,
    default: () => {}
  },
  miniDateProp: {
    type: String,
    default: ''
  },
  allowAllDates: {
    type: Boolean,
    default: false
  }
}
